import { css } from 'styled-system/css';
import { SplitSection } from '../SplitSection';
import { FaqEntry } from './FaqEntry';
import { faqItems } from './faqItems';

export function FaqSection() {
  return (
    <SplitSection
      id="faq"
      label="Frequently asked questions"
      eyebrow="FAQ"
      title="Questions people ask before they try it"
      description="Short answers here. The longer versions, with every step, live in the docs."
      className={css({
        paddingTop: { base: '12', md: '16' },
        paddingBottom: { base: '16', md: '24' },
        scrollMarginTop: '20',
      })}
    >
      <div>
        {faqItems.map((item) => (
          <FaqEntry key={item.id} item={item} />
        ))}
      </div>
    </SplitSection>
  );
}
